import {createStore, withProps} from '@ngneat/elf';
import {generatePathToPermissions} from '../../utils/helpers';
import {DashboardAccessMap} from '../../../../userway/sdk/UserWayApiClient';

export const initUserPermissionState = {
  manageBilling: {
    subscriptionPage: false,
    billingInvoicesPage: false,
    billingOperations: false,
  },
  manageMyAccount: {
    manageMyAccountPage: false,
    changePassword: false,
    changeEmail: false,
    ipWhiteList: false,
    manage2fa: false,
  },
  manageTeam: {
    teamManagementService: false,
    teamList: false,
    subAccountList: true,
    teamManagementPage: {
      enforce2FAService: false,
      editTeamService: false,
      inviteTeamMemberService: false,
      addSubAccountService: true,
    },
  },
  manageEmbedCode: {
    manageEmbedCodeTab: false,
    needHelp: false,
    onboarding: false,
    oneOnOne: false,
  },
  manageSites: {
    siteList: false,
    deletedSiteList: false,
    addSiteService: false,
    getCSVListOfSiteService: false,
    agencyData: false,
    overviewPage: {
      overviewService: false,
      needHelp: false,
      onboarding: false,
      oneOnOne: false,
      currentPlan: false,
      pdfReport: false,
      accessibilityReport: false,
      statisticsReport: false,
      statisticsMedia: false,
      planDetails: false,
    },
    configurePage: {
      configureService: false,
    },
    reportPage: {
      reportService: false,
    },
    statPage: {
      statService: false,
    },
    customizePage: {
      customizeService: false,
      buttonColor: false,
      buttonType: false,
      LSTButtons: false,
      buttonLocation: false,
      widgetCustomization: false,
      modifyMenu: false,
      widgetType: false,
      language: false,
      customTrigger: false,
      saveToAll: false,
    },
    addonPage: {
      switchToAnnualButton: false,
      addonService: false,
      modifyMenu: false,
      liveSiteTranslation: false,
      getCSVLstStats: false,
    },
    settingsPage: {
      settingsService: false,
    },
    statementPage: {
      statementService: false,
      accessibilityStatement: {
        downloadStatement: false,
        customizeStatement: {
          customizeStatementService: false,
          statementGenerator: false,
          statementProducts: false,
        },
      },
      accessibilityStatementLink: false,
    },
    reportedIssuesPage: {
      reportedIssuesService: false,
      reportConfiguration: {
        reportConfigurationService: false,
      },
      reportedIssuesList: {
        reportedIssuesListService: false,
      },
    },
  },
  manageScans: {
    scansTab: false,
  },
  manageImageAlts: {
    imageAltsTab: false,
  },
  managePdfs: {
    pdfsTab: false,
    remediationPlanPanel: false,
  },
  manageAccessibilityServices: {
    manageAccessibilityServicesTab: false,
    manageAccessibilityAudit: false,
    manageAccessibilityVPAT: false,
    manageAccessibilityManagedAccessibility: false,
    manageAccessibilityLegalSupport: false,
    manageAccessibilityLegalVideosRemediations: false,
  },
  manageDeveloperResources: {
    manageDeveloperResourcesTab: false,
    manageDeveloperResourcesServerSideApi: false,
  },
  notifications: {
    topBar: false,
    drawer: false,
  },
  manageAgencyResources: {
    manageAgencyResourcesTab: false,
    manageAgencyResourcesBanner: false,
    manageAgencyResourcesDiscount: false,
    manageAgencyResourcesContact: false,
    manageAgencyResourcesAssets: false,
    manageAgencyResourcesVideo: false,
    manageAgencyResourcesNewsletter: false,
    manageAgencyResourcesLanding: false,
    manageAgencyResourcesPosts: false,
  },
  manageRegTracker: {
    manageRegTrackerTab: false,
    manageRegTrackerCountrySelector: false,
    manageRegTrackerMetrics: {
      risk: false,
      enforcement: false,
      timeSensitivity: false,
    },
    manageRegTrackerMap: false,
    manageRegTrackerOverall: false,
    manageRegTrackerCompliance: false,
    manageRegTrackerRisk: false,
    manageRegTrackerEnforcement: false,
    manageRegTrackerDisproportionateBurden: false,
    manageRegTrackerTimeline: false,
    manageRegTrackerChecklist: false,
    manageRegTrackerLaws: false,
    manageRegTrackerUpdates: false,
  },
  manageSupportServices: {
    manageSupportServicesTab: false,
  },
  becomeAPartnerLink: false,
};

export const UserPermissions = generatePathToPermissions(initUserPermissionState);

export function createInitialState(): DashboardAccessMap {
  return initUserPermissionState;
}

export const userPermissionsStore = createStore(
  {name: 'user-permissions'},
  withProps<DashboardAccessMap>(createInitialState()),
);
